module.exports = __webpack_public_path__ + "img/yellowSapphire.890b8d8.webp";